import { WorkflowStatus } from "@certa/common/components/WorkflowStatus";
import { ChokidarWFStatusPermissionBasedOnToggle } from "@certa/common/components/ChokidarWFStatusPermissionBasedOnToggle";
import { useState } from "react";
import { TaskStepgroupOverlay } from "../../TaskStepGroupOverlay";
import { BaseDialog } from "@certa/catalyst/components/Dialog";
import { useNewWorkflowProgressMapDisabled } from "@certa/common/toggles/useNewWorkflowProgressMapDisabled";
import { useNavigate } from "react-router";
import { getWorkflowProgressMapRoute } from "@certa/common/utils/routes";
import { PRINT_ELEMENT_IDS } from "@certa/common/constants";

type WorkflowStatusWithOverviewProps = {
  processId: number;
  status?: string;
  statusColorCode?: string | null;
  width?: number;
  onDialogOpenChange?: (isOpen: boolean) => void;
  onOpenDialog?: () => void;
};

const WorkflowStatusWithOverview = ({
  processId,
  status,
  statusColorCode,
  width,
  onDialogOpenChange,
  onOpenDialog
}: WorkflowStatusWithOverviewProps) => {
  const [shouldShowDialog, setShouldShowDialog] = useState(false);

  const navigate = useNavigate();
  const isNewWorkflowProgressMapDisabled = useNewWorkflowProgressMapDisabled();

  const onOpen = () => {
    if (isNewWorkflowProgressMapDisabled) {
      setShouldShowDialog(true);
      onDialogOpenChange?.(true);
      onOpenDialog?.();
    } else {
      navigate(getWorkflowProgressMapRoute(processId));
    }
  };

  const onClose = () => {
    setShouldShowDialog(false);
    onDialogOpenChange?.(false);
  };

  return (
    <>
      <div id={PRINT_ELEMENT_IDS.WORKFLOW_STATUS}>
        <ChokidarWFStatusPermissionBasedOnToggle processId={processId}>
          <WorkflowStatus
            onClick={onOpen}
            ellipsis={width}
            label={status}
            customColorCode={statusColorCode}
            size="Medium"
          />
        </ChokidarWFStatusPermissionBasedOnToggle>
      </div>

      <BaseDialog
        show={shouldShowDialog}
        onClose={onClose}
        width="85%"
        aria-label={status || ""}
      >
        <TaskStepgroupOverlay
          processId={processId}
          hideOverlay={onClose}
          shouldHideCloseButton={false}
        />
      </BaseDialog>
    </>
  );
};

export { WorkflowStatusWithOverview };
